import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { TextField } from "@mui/material";
import { useFieldError } from "../../../../shared/helper/useFieldError";

export const EditOriginalNameCell = ({ cell, row, locatedError, setEditingValue }) => {
  const rowId = row.original?.tempId || row.original?._id || row.id;
  const initialValue = cell.getValue() ?? "";
  const [value, setValue] = useState(initialValue);
  const [showError, helperText] = useFieldError(locatedError, rowId, "originalName");

  useEffect(() => {
    setEditingValue(rowId, "originalName", value);
  }, [rowId, value]);

  return (
    <TextField
      id="originalNameInput"
      fullWidth
      value={value}
      onChange={(e) => setValue(e.target.value)}
      error={showError}
      helperText={helperText}
      size="small"
      variant="outlined"
    />
  );
};

EditOriginalNameCell.propTypes = {
  cell: PropTypes.shape({
    getValue: PropTypes.func.isRequired,
  }).isRequired,
  row: PropTypes.shape({
    original: PropTypes.object,
    id: PropTypes.string,
  }).isRequired,
  locatedError: PropTypes.object,
  setEditingValue: PropTypes.func.isRequired,
};